import { scaleTime } from 'd3';
import { ScaleTime } from 'd3-scale';
import { ReactNode } from 'react';
import { createCtx } from '../helpers/context';
import { TimeRange } from '../types/date';

export function createScale(from: number, to: number, width: number) {
  return scaleTime()
    .domain([new Date(from), new Date(to)])
    .range([0, width]);
}

export type GraphScale = ScaleTime<number, number>;

interface GraphCtx {
  width: number;
  height: number;
  range: TimeRange<number>;
  scale: GraphScale;
  tz?: string;
  compressed?: boolean;
}

export interface GraphChildProps {
  readonly parentHeight: number;
  readonly parentWidth: number;
  readonly scale: GraphScale;
}

export const [useGraphCtx, GraphCtxProviderInternal] = createCtx<GraphCtx>();

export function GraphCtxProvider(p: {
  value: Omit<GraphCtx, 'scale'>;
  children: (scale: GraphScale) => ReactNode;
}) {
  const { children, value } = p;
  const scale = createScale(value.range.from, value.range.to, value.width);

  return (
    <GraphCtxProviderInternal
      value={{
        ...value,
        scale: scale,
      }}
    >
      {children(scale)}
    </GraphCtxProviderInternal>
  );
}
